module.exports = __webpack_public_path__ + "img/koncertak.e796fbb1.png";